<template>
  <div>
    <DashboardNavbar />
    <router-view />
    <LightFooter />
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import Navbar from '@/views/dashboard/partials/Navbar.vue';
import LightFooter from '@/views/dashboard/partials/LightFooter.vue';

export default defineComponent({
  name: 'DashboardLayout',
  components: {
    DashboardNavbar: Navbar,
    LightFooter,
  },
});
</script>
